/**
 * Shared mutable state for Truck Loading game.
 */
import baseConfig from '@config/baseConfig';

const phaserConfig = baseConfig();

export const config = {
  width: phaserConfig.width,
  height: phaserConfig.height,
  audio: {
    engine: null,
    conveyor: null,
    clunk: null,
    correct: null,
    wrong: null,
    fanfare: null,
  },
};

export const gameState = {
  roundIndex: 0,
  totalRounds: 3,
  mistakes: 0,
  delivered: 0,
  // per-round transient
  target: 0,
  correctCount: 0,
  loadedCount: 0,
};

export function resetGameState() {
  gameState.roundIndex = 0;
  gameState.mistakes = 0;
  gameState.delivered = 0;
  gameState.target = 0;
  gameState.correctCount = 0;
  gameState.loadedCount = 0;
}
